<template>
  <div class="row dvQuickGlance forMember">

    <div class="col s12 l6 row valign-wrapper dvQuickGlance-main">

      <div class="col s12 l7 dvQuickGlance-info valign-wrapper">
        <div class="dvQuickGlance-image">
          <div class="dvQuickGlance-image-placer flexCenterAll"><span class="icon-fs_user"></span></div>
          <img class="dvQuickGlance-image-pic responsive-img" :src="member.photo" v-show="member.photo && member.photo.length > 0"/>
          <!-- <a class="dvQuickGlance-image-link flexCenterAll" href="#"><span class="icon-editor_camera"></span></a> -->
        </div> <!-- dvQuickGlance-image -->
        <div class="dvQuickGlance-user">
          <div class="dvQuickGlance-user-welcome"><strong>{{ $store.getters.formatFullName(member.first_name, member.last_name) || member.email }}</strong></div>
          <div class="dvQuickGlance-user-team">{{ team.channel }} - {{ team.team }}</div>
          <div class="dvQuickGlance-user-position">{{ member.position }}</div>
        </div> <!-- dvQuickGlance-user -->
      </div> <!-- dvQuickGlance-info -->

      <div class="col s12 l5 dvQuickGlance-action">
        <a :href="'mailto:'+member.email" class="waves-effect waves-light btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Contact</div></a>
        <a
          ref="tippy_sub_menu"
          name="more-menu"
          class="waves-effect waves-dark btn-Menu-more flexCenterAll" href="#"><span class="icon-nav_more_horz"></span></a>

        <tippy
         to="more-menu"
         placement="bottom-end"
         offset="[10, 2]"
         interactive
         arrow
         trigger="click">
         <div class="morePopMenuBox-content ">

           <router-link
            v-if="summary.pending > 0"
             class="morePopMenuBox-content-item"
             :to="{ name:'admin_team_member_resolve', params: { id: member.id, team_id: team.id, referral_id: 'all' } }">
             <span class="icon-action_check"></span>Resolve
           </router-link>

           <a
           @click="confirm({
             id: member.id,
             type: 'remove-member'
           })"
           href="javascript:void(0)" class="morePopMenuBox-content-item">
             <span class="icon-action_delete"></span>Remove
           </a>

         </div>
       </tippy>


      </div> <!-- dvQuickGlance-action -->
    </div> <!-- dvQuickGlance-main -->

    <div class="col s12 l6 dvQuickGlance-tabs">
      <div class="dvTabs">
        <div
          :class="{ isActive: this.$route.params.status == 'valid' ? true : false }"
          @click="filterByReferralStatus('valid')"
          class="waves-effect waves-light dvTabs-item isValid">
          Valid<div class="dvTabs-tally">{{ summary.valid }}</div>
        </div>
        <div
          :class="{ isActive: this.$route.params.status == 'pending' ? true : false }"
          @click="filterByReferralStatus('pending')"
          class="waves-effect waves-light dvTabs-item isPending">
          Pending<div class="dvTabs-tally">{{ summary.pending }}</div>
        </div>
        <div
          :class="{ isActive: this.$route.params.status == 'expiring' ? true : false }"
          @click="filterByReferralStatus('expiring')"
          class="waves-effect waves-light dvTabs-item isExpiring">
          Expiring<div class="dvTabs-tally">{{ summary.expiring }}</div>
        </div>
        <div
          :class="{ isActive: this.$route.params.status == 'archive' ? true : false }"
          @click="filterByReferralStatus('archive')"
          class="waves-effect waves-light dvTabs-item isArchive">
          Archive<div class="dvTabs-tally">{{ summary.archive }}</div>
        </div>
      </div> <!-- dvTabs -->
    </div>
  </div> <!-- dvQuickGlance -->
</template>

<script>

  export default {
    name: 'teams-member-headernav',
    props: ['member', 'summary', 'team'],
    data: () => ({

    }),
    computed: {

    },
    methods: {
      confirm (action){
        let el = this.$refs['tippy_menu'+this.idx];
        if (el && el._tippy) {
            el._tippy.hide()
        }
        this.$emit('confirm', action)
      },
      filterByReferralStatus: function(valid){
        this.$emit('filterByReferralStatus', valid);
      }
    },
    mounted() {

    },
    components: {

    }
  }
</script>
